// This file has global variables to alter the revalidation time of statically generated data and duplication time of requests.

// 8 hours in seconds
export const revalidateData = 28800;

// 8 hours in milliseconds
export const duplicateRequest = 28800000;
